import toInteger from 'lodash/toInteger';

export default {
  setStudent(state, student) {
    state.student = student;
  },

  selectBilling(state, { billing }) {
    state.currentBilling = billing;
    state.currentBillingId = billing.id;
    localStorage.setItem('currentBillingId', billing.id);
  },

  setCurrentContract(state, contract) {
    state.currentContract = contract;
  },

  setStudentCards(state, cards) {
    state.studentCards = cards;
  },

  setBillings(state, billings) {
    state.billings = billings;
    state.currentBillingId = toInteger(localStorage.getItem('currentBillingId')) || billings[0].id;
    state.currentBilling = state.billings.find((b) => b.id === state.currentBillingId);

    if (!state.currentBilling) {
      [state.currentBilling] = state.billings;
      state.currentBillingId = state.currentBilling.id;
    }
  },

  setCurrentBill(state, bill) {
    state.currentBill = bill;
    state.loadingCurrentBill = false;
  },

  setCurrentBilling(state, billing) {
    state.currentBilling = billing;
    state.currentBillingId = billing.id;
    localStorage.setItem('currentBillingId', billing.id);
  },

  setOverdueBills(state, bills) {
    state.overdueBills = bills;
  },

  setNotPaidBills(state, bills) {
    state.notPaidBills = bills;
  },

  setNextUnpaidBill(state, bill) {
    state.nextUnpaidBill = bill;
  },

  setConfigs(state, configs) {
    state.configs = configs;
  },

  setReenrollment(state, reenrollment) {
    state.currentReenrollment = reenrollment;
  },
};
